<template>
  <TMainForm :script-id="scriptId" :interception="interception" :buttons="buttons" :default-design="defaultDesign"
    :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" />
</template>

<script setup>
/**
 * TTMMobileStationForm
 */
import TMainForm from './TMainForm.vue';
import { REPEATED_FORM_DESIGNS } from './constants';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});

const buttons = [];
const defaultDesign = REPEATED_FORM_DESIGNS.design;
const defaultChangeScript = REPEATED_FORM_DESIGNS.changeScript;
const defaultProccessScript = REPEATED_FORM_DESIGNS.processScript;
</script>
